import styled from 'styled-components';

export const Wrapper = styled.div`
  && {
    .ant-input-search-button {
      background-color: #ff8a00;
      color: white;
      border: none;
    }
    .ant-modal-content {
      width: 900px !important;
    }
    .section {
      padding: 25px 40px;
    }
    .header-choose {
      height: 75px;
      background-color: rgba(236, 255, 184, 1);
      padding-left: 60px;
      display: flex;
      align-items: center;
    }
    .info-step {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .table-create {
      margin-top: 15px;
    }
    .info-detail-bill {
      margin-top: 30px;
    }
    .add-statement {
      margin-top: 20px;
      background-color: #f6f6f6;
      border-radius: 10px;
      .text {
        padding: 10px 0px 10px 20px;
        border-bottom: 2px solid white;
      }
      .form-add {
        padding: 30px 0px 20px 20px;
      }
      .btn-add {
        font-size: 14px;
        min-width: 64px;
        border: none;
        background-color: #ff8a00;
        color: white;
        &[disabled] {
          color: rgba(0, 0, 0, 0.25);
          background: #f5f5f5;
          border: 1px solid #d9d9d9;
        }
      }
      .label-select {
        margin-bottom: 1px;
      }
      .btn-sbm {
        margin-top: 22px;
      }
    }
    .confirm-create-bill {
      text-align: center;
      margin-top: 30px;
    }
    .confirm-step {
      margin-top: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .btn-save {
      background-color: #ff8a00;
      border-radius: 4px;
      color: white;
      border: none;
      width: 240px;
      height: 60px;
    }
    .btn-cancel-save {
      width: 112px;
      height: 60px;
      background-color: #c4c4c4;
      border-radius: 4px;
      border: none;
      color: white;
      margin-right: 10px;
    }
    .table {
      margin-top: 40px;
    }
    .read-only input {
      pointer-events: none;
    }
    .error {
      color: red;
    }
  }
`;
